<template>
	<div class="fee-card">
		<van-cell center :title="title" :border="false" v-if="showTitle" style="font-size: 16px; margin-bottom: 10px">
			<template #icon>
				<div class="left-icon">|</div>
			</template>
		</van-cell>
		<van-grid :border="false" :column-num="columnNums">
			<van-grid-item
				v-for="(item, index) in listArr"
				:key="index"
				@click="handleItemClick(item)"
				v-show="handleItemShow(item)"
				style="min-height: 40px">
				<template #icon v-if="$utils.isNotEmpty(item.src)">
					<div class="fee-item-image-wrapper">
						<div :class="feeItemImageClass(item)" class="fee-item-icon-size"></div>
					</div>
				</template>
				<template #text>
					<span class="van-grid-item__text van-multi-ellipsis--l2" :style="feeItemFontStyle(item)">
						{{ item.name }}
					</span>
				</template>
			</van-grid-item>
		</van-grid>
	</div>
</template>

<script>
import utils from '@/utils/util'
import apiChooseFee from 'api/choose-fee'
import { Info } from 'vant'

export default {
	name: 'FeeCard',
	props: {
		listArr: Array,
		title: String,
		columnNums: {
			type: [String, Number],
			default: 3
		},
		showTitle: {
			type: Boolean,
			default: true
		}
	},
	methods: {
		feeItemImageClass(item) {
			if (utils.isNotEmpty(item.src)) {
				return `fee-item-${item.src}-img`
			} else {
				return 'fee-item-default-img'
			}
		},
		feeItemFontStyle(item) {
			if (utils.isNotEmpty(item.style)) {
				return item.style
			}
		},

		handleItemClick(item) {
			console.log('点击的item-----', item)
			if (utils.isNotEmpty(item.router)) {
				if (utils.isNotEmpty(item.type) && item.type == 'external') {
					window.location.href = item.router
				} else {
					console.log(item.router, item.param)
					this.$router.push({ path: item.router, query: item.param ? item.param : {} })
				}
			} else if (item.onClick) {
				item.onClick(item)
			}
		},
		handleItemShow(item) {
			if (item.needCheck) {
				if (item.show) {
					return true
				} else {
					return false
				}
			} else {
				if (item.type == 'external') {
					if (utils.isWxWorkBrowser()) {
						return true
					} else {
						return false
					}
				} else {
					return true
				}
			}
		}
	}
}
</script>

<style lang="scss" scoped></style>
